/**
 * Validates a working hours string.
 * Valid formats: "cerrado", "07:00-18:00", "07:00-14:00, 15:30-18:00"
 * Returns { valid: boolean, error?: string }
 */
export function validateHoursFormat(str) {
  if (!str || !str.trim()) return { valid: true };
  const s = str.trim().toLowerCase();
  if (s === "cerrado") return { valid: true };
  const blocks = s.split(",").map(b => b.trim());
  const re = /^\d{2}:\d{2}-\d{2}:\d{2}$/;
  for (const block of blocks) {
    if (!re.test(block)) return { valid: false, error: `Formato incorrecto: "${block}". Usa HH:MM-HH:MM` };
    const [start, end] = block.split("-");
    const [sh, sm] = start.split(":").map(Number);
    const [eh, em] = end.split(":").map(Number);
    if (sh > 23 || sm > 59 || eh > 23 || em > 59) return { valid: false, error: `Hora fuera de rango en "${block}"` };
    if (sh * 60 + sm >= eh * 60 + em) return { valid: false, error: `Hora inicio >= fin en "${block}"` };
  }
  // Check blocks don't overlap
  if (blocks.length > 1) {
    const ranges = blocks.map(b => {
      const [s, e] = b.split("-");
      return { start: parseInt(s) * 60 + parseInt(s.split(":")[1]), end: parseInt(e) * 60 + parseInt(e.split(":")[1]) };
    });
    // Actually reparse correctly
    const parsed = blocks.map(b => {
      const [s, e] = b.split("-");
      const [sh, sm] = s.split(":").map(Number);
      const [eh, em] = e.split(":").map(Number);
      return { start: sh * 60 + sm, end: eh * 60 + em };
    });
    for (let i = 1; i < parsed.length; i++) {
      if (parsed[i].start < parsed[i - 1].end) {
        return { valid: false, error: "Los bloques horarios se solapan" };
      }
    }
  }
  return { valid: true };
}

/**
 * Generate time slots from a working hours string.
 * Supports split schedules: "07:00-14:00, 15:30-18:00"
 * @param {string} rangeStr - "HH:MM-HH:MM" or "HH:MM-HH:MM, HH:MM-HH:MM" or "cerrado"
 * @param {number} interval - minutes between slots (default 20)
 * @returns {string[]} - array of "HH:MM" slot strings
 */
export function generateSlots(rangeStr, interval = 20) {
  if (!rangeStr || rangeStr.toLowerCase().trim() === "cerrado") return [];
  const blocks = rangeStr.split(",").map(b => b.trim());
  const slots = [];
  for (const block of blocks) {
    const parts = block.split("-");
    if (parts.length !== 2) continue;
    const [sh, sm] = parts[0].split(":").map(Number);
    const [eh, em] = parts[1].split(":").map(Number);
    if (isNaN(sh) || isNaN(sm) || isNaN(eh) || isNaN(em)) continue;
    const start = sh * 60 + sm;
    const end = eh * 60 + em;
    for (let m = start; m < end; m += interval) {
      slots.push(`${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`);
    }
  }
  return slots;
}
